import React, { useContext } from 'react'
import { AuthContext } from '../../../Api/firebase'
import { getTeamColorByFullName } from '../../../Utils'
import { FavTeamCon } from './styles'

export const FavTeam: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { favTeam } = useContext(AuthContext)!


  return (
    <>
    { favTeam && <FavTeamCon teamColor={getTeamColorByFullName(favTeam)}><p className='team'>{favTeam.charAt(0).toUpperCase() + favTeam.slice(1)} Fan</p></FavTeamCon>}
    </>
  )
}